import { DateTime as DateTimeLuxon } from 'luxon'
import { LANGUAGE, LANGUAGE_LOCALE } from '../locales/config'
import { DateTime } from '../types/patient-api-gateway/google/type/datetime'

export function getLocale(preferredLanguage: string) {
  if (!preferredLanguage) return navigator.language

  return preferredLanguage === LANGUAGE.SV
    ? LANGUAGE_LOCALE.SV
    : LANGUAGE_LOCALE.EN
}

export function formatDate(date: Date | null, language = 'sv-SE') {
  if (!date) return ''

  return DateTimeLuxon.fromJSDate(date).toFormat('d LLL HH:mm', {
    locale: getLocale(language),
  })
}

export function createDateFromObject(dateObj?: DateTime): DateTimeLuxon {
  if (!dateObj) return DateTimeLuxon.now()

  return DateTimeLuxon.local(
    dateObj?.year ?? new Date().getFullYear(),
    dateObj?.month ?? new Date().getMonth() + 1,
    dateObj?.day ?? new Date().getDate(),
    dateObj?.hours ?? 0,
    dateObj?.minutes ?? 0,
    dateObj?.seconds ?? 0,
    dateObj?.nanos ? dateObj.nanos / 1_000_000 : 0,
    {
      zone: dateObj?.timeZone?.id,
    }
  )
}

export function shiftClientTimeZone(date: Date) {
  return new Date(
    date.getTime() - new Date().getTimezoneOffset() * 60000
  ).toISOString()
}

export function toGoogleDateTime(dt: DateTimeLuxon | undefined): DateTime {
  if (!dt) {
    return {
      year: 0,
      month: 0,
      day: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      nanos: 0,
    }
  }

  return {
    year: dt.year,
    month: dt.month,
    day: dt.day,
    hours: dt.hour,
    minutes: dt.minute,
    seconds: dt.second,
    nanos: dt.millisecond * 1_000_000,
    timeZone: { id: dt.zoneName },
  }
}
